import request from '@/axios'
// import request from '@/utils/request'

export function Lead_list (query) {
  
  return request({
    url: query.filter_id ? `/leads/list_leads/${query.limit}/${query.customerId}?page=${query.page}&filter_id=${query.filter_id}` : 
      `/leads/list_leads/${query.limit}/${query.customerId}?page=${query.page}`,

    method: 'POST',
    data:query
  })
}

/**
 *
 * @created_by : Sujay Ghosh(06-07-2020)
 */
export function create_lead (query) {
  return request({
    url: '/leads/create_leads',
    method: 'POST',
    data: query
  })
}

export function Delete_Leads (payload) {
  // 
  return request({
    url: '/leads/delete_leads',
    method: 'POST',
    data: payload
  })
}
// http://8a90ece350ed.ngrok.io/api/active_deactive_leads
// http://localhost:8000/api/delete_leads
// {
//     "leads_id": [3]
// }

//updated at 7:47 by yasin
export function update_lead_list (query) {
  return request({
    url:'/leads/edit_leads',
    method: 'PUT',
    data: query
  })
}
// http://8a90ece350ed.ngrok.io/api/active_deactive_leads
// {
// "leads_id": "3",
// "type" : "0"
// }
export function activeDeactiveLeads (payload) {
  return request({
    url:'/leads/active_deactive_leads',
    method: 'POST',
    data: payload
  })
}
export function active_lead_status (customerId) {
  return request({
    url:`/leads/fetch_active_leads_status/${customerId}`,
    method: 'GET'
  })
}
// http://ab0119d7d1af.ngrok.io/api/leads/change_leads_status
export function change_leads_status (payload) {
  return request({
    url:'/leads/change_leads_status',
    method: 'POST',
    data: payload
  })
}
export function all_leads_status (customerId) {
  return request({
    url:`/leads/leads_status_list/${customerId}`,
    method: 'GET'
  })
}
export function arrange_leads_status (payload) {
  return request({
    url:'/leads/arrange_leads_status ',
    method: 'POST',
    data: payload
  })
}
// http://localhost:8000/api/leads/create_leads_status
export function create_lead_status (payload) {
  return request({
    url:'/leads/create_leads_status',
    method: 'POST',
    data: payload
  })
}
export function edit_status (payload) {
  return request({
    url:'/leads/edit_leads_status',
    method: 'PUT',
    data: payload
  })
}
export function delete_status (leads_status_id) {
  return request({
    url:`/leads/delete_leads_status/${leads_status_id}`,
    method: 'GET'
  })
}

export function getFilterList (query, params) {
  
  return request({
    // url:`filter/filterlist/${query}`,
    // method:'GET'
    url: `/leads/list_leads/${query.limit}/${query.customer_id}?page=${query.page}`,
    params,
    method:'GET'
  })
}

//forfilters

export function persona_list () {
  return request({
    url : '/leads/persona_list',
    method: 'GET'
  })
}

export function leadsConversion (leadsId, customer_id) {
  return request({
    url:`leads/leads_conversion/${leadsId}/${customer_id}`,
    method: 'GET'
  })
}

export function bulkUpdate (payload) {
  return request({
    url: '/leads/bulk_update/',
    method:'PUT',
    data:payload
  })
}

export function bulkEmailApi (payload) {

  return request({

    url: '/leads/bulk_email/',
    method:'POST',
    data:payload
  })
}
export function createMinorApi (payload, customer_id) {
  return request({
    url: `leads/add_minor/${customer_id}`,
    method: 'POST',
    data:payload
  })
}
export function list_mionor (customer_id, lead_id) {
  return request({
    url: `leads/list_minor/${customer_id}/${lead_id}`,
    method: 'GET'
  })
}
export function updateMinor (payload, customer_id) {
  return request({
    url: `leads/update_minor_details/${customer_id}`,
    method: 'PUT',
    data:payload
  })
}
export function DeleteMinor (payload, customer_id) {
  return request({
    url: `leads/delete_minor/${customer_id}`,
    method: 'DELETE',
    data:payload
  })
}
export function SinglefileUploadApi (payload) {
  return request({
    url: '/leads/file/create',
    method: 'POST',
    data:payload
  })
}
export function SinglefileDeleApi (payload) {
  return request({
    url: 'leads/file/delete',
    method: 'DELETE',
    data:payload
  })
}
export function fetchleadBySearch (payload, query_page, query) {
  
  return request({
    url: `/leads/list_by_search/${query_page.limit}?attribute=${query.attribute}&direction=${query.direction}&field_type=${query.field_type}&page=${query_page.current_page}`,
    method: 'POST',
    data:payload
  })
}

export function getAllLeadFiles (lead_id) {
  return request({
    url: `leads/file/list/${lead_id}`,
    method: 'GET'
  })
}